/* An Underscore template used by ToolbarHelper to render notifications
 * for the old notifications centre.
 *
 * Arguments:
 *      - response:
 *          the data from the /user/tasks endpoint
 *      - canAudit:
 *          corresponds to a previously CF permission check:
 *              rc.user.hasAnyPermission(
 *                  actions=['media.create', 'media.audit.upload'],
 *                  account=rc.account)
 *
 * Adapted from 'bynder-platform/bynder/views/navigation/task-feed-template.cfm'
 * The differences are:
 *      - A ColdFusion permission check is replaced by a parameter to the
 *        template (canAudit).
 *      - A <cfswitch> block was removed since, as far as I could tell, it was
 *        not used.
 *      - ColdFusion localisation is changed to FE localisation.
 */

export function getTaskFeedTemplate(translate: (translationKey: string) => string) {
	const timeIconSvg = `
        <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" width="18px" height="18px" aria-hidden="true" style="vertical-align: middle;">
            <path fill="currentColor" d="M11 7h1.5v5.25l4.5 2.67-.75 1.23L11 13V7Z"></path><path fill="currentColor" fill-rule="evenodd" d="M2 12C2 6.48 6.47 2 11.99 2 17.52 2 22 6.48 22 12s-4.48 10-10.01 10C6.47 22 2 17.52 2 12Zm2 0c0 4.42 3.58 8 8 8s8-3.58 8-8-3.58-8-8-8-8 3.58-8 8Z" clip-rule="evenodd"></path>
        </svg>
    `;

	const downloadIconSvg = `
        <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" width="18px" height="18px" aria-hidden="true" style="vertical-align: middle;">
            <path fill="currentColor" d="M18 15v3H6v-3H4v3c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-3h-2Zm-1-4-1.41-1.41L13 12.17V4h-2v8.17L8.41 9.59 7 11l5 5 5-5Z"></path>
        </svg>
    `;

	return `<% if (is.set(response.items) && response.items.length > 0) { %>
<% _.each(response.items, function(item) { %>
<% var object = item.object; %>
<li class="clearfix task-dropdown-item <% if (!item.reviewed) { %>new-task<% } %>">

    <% if (item.type === 'transferbox') { %>
    <p>
        ${downloadIconSvg}
        <span class="link-user">
            <%- object.emailCreated %>
        </span>
        ${translate('activity.sendWithDropbox')}
    </p>
    <time><%- item.timeAgo %></time>
    <div class="actions">
        <!-- <cfif (rc.user.hasAnyPermission(actions=['media.create', 'media.audit.upload'], account=rc.account))> -->
        <% if (canAudit) { %>
            <a href="/waitingroom/view/<%- object.id %>/?access=0&accesstype=dropbox"
                class="action-btn blue"
                title=${translate('generalAudit')}>
            ${translate('generalAudit')}
            </a>
        <!-- <cfelse> -->
        <% } else { %>
            <a href="/transferbox/detail/<%- object.id %>/"
                class="action-btn blue"
                title=${translate('generalWatch')}>
                ${translate('generalWatch')}
            </a>
        <!-- </cfid> -->
        <% } %>
    </div>
    <% } else if (item.type === 'zip' || item.type === 'videoedit' || item.type === 'imageedit') { %>
    <p>
    ${downloadIconSvg}
        <a href="#" title=${translate('generalTaskDownloadReady')}>
        <%- object.name %>
        </a> ${translate('generalTaskDownloadReady')}
    </p>
    <time><%- item.timeAgo %></time>
    <div class="actions">
        <a href="#"
            data-id="<%- object.id %>"
            class="remove-task ">
            ${downloadIconSvg}
        </a>
        <a href="#"
            class="action-btn blue download-task"
            data-id="<%- object.id %>"
            title=${translate('generalDownload')}>
            ${downloadIconSvg} ${translate('generalDownload')}
        </a>
    </div>
    <% } else if (item.type === 'accessRequest') { %>
    <p>
        ${timeIconSvg}
        <a href="#" title="<%- item.userName %>">
            <%- item.userName %>
        </a>
        <% if (item.userActive === 0) { %>
        <i>(generalInactive)</i>
        <% } %>
        <% if (object.contentType === 'download') { %>
        ${translate('download.requestSent')}
        <% } else { %>
        ${translate('access.requestSentFor')} <%- object.accessType %>
        <% } %>
    </p>
    <time><%- item.timeAgo %></time>
    <div class="actions">
        <a href="/waitingroom/view/<%- object.requestId %>/?access=<%- object.access %>&accessType=<%- object.accessType %>"
            class="action-btn blue"
            title=${translate('generalAudit')}>
        ${downloadIconSvg} ${translate('generalAudit')}
        </a>
    </div>
    <% } %>
</li>
<% }); %>
<% } else { %>
<li>${translate('activity.noTasks')}</li>
<% } %>`;
}
